import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '../api/client'

/** Das Einkauf-Board: alle Beschaffungs-Einträge (restock + order_oneoff) der Werkstatt. */
export function useProcurement() {
  return useQuery({ queryKey: ['procurement'], queryFn: api.listProcurement })
}

/**
 * Beschaffungs-Eintrag eine Stufe weiterschalten. Bei restock→delivered bucht der Server den Wareneingang
 * ins Lager — darum invalidieren wir zusätzlich die Inventar-Queries. Ein order_oneoff-Wechsel spiegelt auf
 * die verknüpfte Auftrags-Position (und den Auftragsstatus) — darum ziehen die Auftrags-Queries nach.
 */
export function useAdvanceProcurement() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (vars: { id: number; status: string }) => api.advanceProcurement(vars.id, { status: vars.status }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['procurement'] })
      void qc.invalidateQueries({ queryKey: ['inventory'] })
      void qc.invalidateQueries({ queryKey: ['orders'] })
    },
  })
}
